import { ANALYTICS } from '../analyticsTokens';
import { SETTINGS } from '../../Settings/tokens';
import type { Tone } from './sisMatchingView';

export const SIS = {
  font: ANALYTICS.font,
  ink: ANALYTICS.ink,
  muted: ANALYTICS.muted,
  disabled: ANALYTICS.disabled,
  background: ANALYTICS.background,
  surface: ANALYTICS.surface,
  divider: ANALYTICS.divider,
  primary: ANALYTICS.primary,
  primaryDark: SETTINGS.primaryDark,
  selectedBg: ANALYTICS.indigo50,
  hoverBg: ANALYTICS.actionHover,
  headerBg: ANALYTICS.grey50,
  totalsBg: ANALYTICS.grey25,
  dotGrey: ANALYTICS.grey100,
  warning: ANALYTICS.orange500,
  warningDark: ANALYTICS.orange800,
  success: ANALYTICS.success,
  successDark: ANALYTICS.green700,
  newBg: ANALYTICS.yellow100,
  cardShadow: ANALYTICS.elevationCard,
  pill: {
    grey: { bg: ANALYTICS.grey50, fg: ANALYTICS.muted },
    yellow: { bg: ANALYTICS.yellow100, fg: ANALYTICS.orange800 },
    green: { bg: ANALYTICS.green50, fg: ANALYTICS.green700 },
  } satisfies Record<Tone, { bg: string; fg: string }>,
} as const;

export const sisText = {
  body1: { fontFamily: SIS.font, fontSize: 16, lineHeight: '24px', color: SIS.ink } as const,
  body1Strong: { fontFamily: SIS.font, fontSize: 16, lineHeight: '24px', fontWeight: 700, color: SIS.ink } as const,
  body2: { fontFamily: SIS.font, fontSize: 14, lineHeight: '20px', color: SIS.ink } as const,
  caption: { fontFamily: SIS.font, fontSize: 13, lineHeight: '20px', color: SIS.muted } as const,
  eyebrow: { fontFamily: SIS.font, fontSize: 12, lineHeight: '16px', fontWeight: 700, letterSpacing: 0, textTransform: 'uppercase', color: SIS.muted } as const,
  h1: { fontFamily: SIS.font, fontSize: 28, lineHeight: '36px', fontWeight: 700, letterSpacing: '-0.5px', color: SIS.ink } as const,
  h3: { fontFamily: SIS.font, fontSize: 24, lineHeight: '32px', fontWeight: 700, color: SIS.ink } as const,
  h4: { fontFamily: SIS.font, fontSize: 20, lineHeight: '28px', fontWeight: 700, color: SIS.ink } as const,
};
